import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import { RequireAuth, RequireModule } from './components/Guards';
import Layout from './components/Layout';
import Login from './pages/Login';
import Overview from './pages/Overview';
import Funnel from './pages/Funnel';
import Partners from './pages/Partners';
import CreatorApprovals from './pages/CreatorApprovals';
import Accounts from './pages/Accounts';
import Agency from './pages/Agency';
import Sites from './pages/Sites';
import Invites from './pages/Invites';
import Emails from './pages/Emails';
import Support from './pages/Support';
import Coupons from './pages/Coupons';
import Bookings from './pages/Bookings';
import Releases from './pages/Releases';
import Prompts from './pages/Prompts';
import Announcements from './pages/Announcements';
import Finances from './pages/Finances';
import Users from './pages/Users';
import Roles from './pages/Roles';
import McpTokens from './pages/McpTokens';

const gated = (module: string, el: JSX.Element) => <RequireModule module={module}>{el}</RequireModule>;

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<RequireAuth><Layout /></RequireAuth>}>
            <Route index element={gated('overview', <Overview />)} />
            <Route path="funnel" element={gated('overview', <Funnel />)} />
            <Route path="accounts" element={gated('accounts', <Accounts />)} />
            <Route path="agency" element={gated('accounts', <Agency />)} />
            <Route path="sites" element={gated('sites', <Sites />)} />
            <Route path="invites" element={gated('invites', <Invites />)} />
            <Route path="emails" element={gated('emails', <Emails />)} />
            <Route path="support" element={gated('support', <Support />)} />
            <Route path="creator-approvals" element={gated('creators', <CreatorApprovals />)} />
            {/* Trials was folded into Sites & Sandboxes; keep old links working. */}
            <Route path="trials" element={<Navigate to="/sites" replace />} />
            <Route path="coupons" element={gated('coupons', <Coupons />)} />
            <Route path="bookings" element={gated('bookings', <Bookings />)} />
            <Route path="releases" element={gated('releases', <Releases />)} />
            <Route path="announcements" element={gated('announcements', <Announcements />)} />
            <Route path="prompts" element={gated('prompts', <Prompts />)} />
            <Route path="finances" element={gated('finances', <Finances />)} />
            <Route path="partners" element={gated('partners', <Partners />)} />
            <Route path="users" element={gated('portal_users', <Users />)} />
            <Route path="roles" element={gated('portal_users', <Roles />)} />
            {/* Self-service: any signed-in staff member manages their OWN tokens. */}
            <Route path="mcp-tokens" element={<McpTokens />} />
          </Route>
          <Route path="*" element={<div className="empty-state"><h2>Not found</h2></div>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
